






































































































	//import { Component, ChangeLogService, BaseTLDetailComponent, AxiosResponse, tlResponseDateToFormDateTimeString } from "../../../Infrastructure/CorBase/CoreBase";

	import { Component } from "../../../Infrastructure/CorBase/CoreBase";
	import ChangeLogDetailBase from "./ChangeLogDetailBase";

	@Component
	export default class ChangeLogDetail extends ChangeLogDetailBase {
		

		created() {
			super.initializeRights(undefined, undefined, 'COR_ChangeLog_Read', 'COR_ChangeLog_Update');
			super.setMainDescription('', 'changeLog.detail');
		}

		showConfirmed() {
			return this.showConfirmedBase();
        }

		mounted() {
			super.mounted();
		};


		validate() {
			return !(true);
		}

		//get showWhoConfirmed(): boolean {
		//	if (this.formData.idWhoConfirmedNavigationLogin) {
		//		return true;
		//	}
		//	return false;
		//}

		//get showWhoChanged(): boolean {
		//	if (this.formData.idWhoChangedNavigationLogin) {
		//		return true;
		//	}
		//	return false;
		//}

		//VaPTODO - vytvorit Base komponenetu na presmerovani na prisluny detail objektu, zatim natvrdo, ale jiz je to na nekolika mistech (detail prihlaseneho uzivatel, zde nekolikrat atd)
		/**když kliknu na uživatele*/
		//detailUserPageWhoChangedClick() {
		//	this.goToUserPage(this.formData.idWhoChanged.toString());
		//}

		//detailUserPageWhoConfirmedClick() {
		//	this.goToUserPage(this.formData.idWhoConfirmed.toString());
		//}

		//goToUserPage(idUser: string) {
		//	this.$router.push({ name: "UserDetail", params: { id: idUser, type: "detail" } });
		//}

		/**když kliknu na zmenovy objekt*/
		//goToObjectDetailClick() {
		//	let idObject: string = this.formData.idChangeObject.toString();
		//	let pagename: string = this.GetPageNameByObjetType(this.formData.idObjectTypeNavigationIdentifier);
		//	this.$router.push({ name: pagename, params: { id: idObject, type: "detail" } });
		//}

		//GetPageNameByObjetType(objectTypeIdentifier: string): string {
		//	switch (objectTypeIdentifier.toUpperCase()) {
		//		case "ENU_COR_CHANGELOG_OBJECTTYPE_PERSON": {
		//			return "PersonDetail";
		//		}
		//		case "ENU_COR_CHANGELOG_OBJECTTYPE_CONNECTION": {
		//			return "ConnectionDetail";
		//		}
		//		case "ENU_COR_CHANGELOG_OBJECTTYPE_WORKINGUNIT": {
		//			return "WorkingUnitDetail";
		//		}
		//		case "ENU_COR_CHANGELOG_OBJECTTYPE_OPERATIONALRECORD": {
		//			return "OperationalRecordDetail";
		//		}
		//		default: {
		//			return '';
		//		}
		//	}
		//}
	}
